import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import {
  Homecontent,
  CardsDetail,
  WelcomeContainer,
  ParentContainer,
} from "./Welcome.style";
import Button from "../Button";
import Homecards from "../Homecards/Homecards";
import {
  batLogo,
  eocLogo,
  rpmLogo,
  marketLogo,
} from "../../assets/images/Welcome/index";
import { useNavigate } from "react-router-dom";
import Login from "../Login/Login";

export const Welcome = () => {
  const navigate = useNavigate();
  return (
    <ParentContainer>
      <div>
        <Navbar />
        <Homecontent>
          <div>
            <WelcomeContainer>
              <h1>Welcome to Vertical-IQ</h1>
              <h4>
                VIQ: Risk management tools for residential new construction
                projects (Single Family and Townhome).
              </h4>
              <p>
                Drawing from our deep expertise in Construction Finance, we
                specialize in evaluating the crucial aspects of residential
                construction projects. From a thorough budget analysis to real
                estate market insights, we assess potential risks and ensure
                you’re informed early on about any shifts in project timelines.
                Partner with us to confidently navigate your construction
                journey from start to finish.
              </p>
              <Homecards
                image={batLogo}
                title="Budget Analysis Report"
                description="Streamline the analysis of construction budgets, evaluating the subject project budget against similar projects, highlighting missing items and projected shortfalls across key cost categories. Our proprietary technology allows you to easily upload a budget and quickly generate these insights. Need to import this data into another platform? Use our tools to speed up that process."
              />
              <Homecards
                image={eocLogo}
                title="Construction Timeline Report"
                description="Do you know if any of the projects in your portfolio are in danger of going past maturity? This report predicts the completion date of residential single family and townhome construction projects. Using data from 100,000+ projects across the US, this prediction model provides a warning if a project’s timeline slips. We can provide you with this insight as early as the first inspection."
              />

              <Button
                onClick={() => {
                  navigate("/contact-us");
                }}
              >
                Get Started
              </Button>
            </WelcomeContainer>
            <Login></Login>
          </div>
        </Homecontent>
        <Footer></Footer>
      </div>
    </ParentContainer>
  );
};

export default Welcome;
